const CustomerSetting = {
  init: function () {
    this.handleSwitcherChange();
  },
  handleSwitcherChange: function () {
    $(document).on("change", '#customer-setting-page input[type="checkbox"]', function () {
      const $checkbox = $(this);
      const isChecked = $checkbox.is(":checked") ? 1 : 0;
      const settingName = $checkbox.attr("name");

      const isParent = $checkbox.data("is-parent") || false;

      if (isParent) {
        const listSettingName = [];

        $checkbox
          .closest(".card")
          .find('input[type="checkbox"]')
          .each(function () {
            listSettingName.push($(this).attr("name"));
          });

        if (isChecked) {
          $checkbox
            .closest(".card")
            .find('input[type="checkbox"]')
            .each(function () {
              $(this).prop("checked", true);
            });
          CustomerSetting.callAPI({
            ...listSettingName.reduce((acc, name) => ({ ...acc, [name]: 1 }), {}),
          });
        } else {
          $checkbox
            .closest(".card")
            .find('input[type="checkbox"]')
            .each(function () {
              $(this).prop("checked", false);
            });
          CustomerSetting.callAPI({
            ...listSettingName.reduce((acc, name) => ({ ...acc, [name]: 0 }), {}),
          });
        }
        return;
      }

      const parentCheckbox = $checkbox.closest(".card").find('input[type="checkbox"][data-is-parent="true"]');

      const params = { [settingName]: isChecked };

      if (parentCheckbox.length) {
        const parentName = parentCheckbox.attr("name");

        const allSiblingUnchecked = $checkbox
          .closest(".card")
          .find('input[type="checkbox"]')
          .not(parentCheckbox)
          .toArray()
          .every((checkbox) => !$(checkbox).is(":checked"));

        if (isChecked) {
          parentCheckbox.prop("checked", true);
          params[parentName] = 1;
        } else if (allSiblingUnchecked) {
          parentCheckbox.prop("checked", false);
          params[parentName] = 0;
        }
      }

      CustomerSetting.callAPI(params);
    });
  },
  callAPI: function (params) {
    $.ajax({
      type: "POST",
      url: customerSettingUrl,
      data: params,
      success: function (response) {
        if (response.error) {
          Theme.showError(response.message);
        } else {
          Theme.showSuccess(response.message);
        }
      },
      error: function (response) {
        Theme.handleError(response);
      },
    });
  },
};

$(document).ready(function () {
  CustomerSetting.init();
});
